module.exports = __webpack_public_path__ + "static/media/footer-logo.899ed16b.svg";